module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/filetypes/office excel icon-3d1d197b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/filetypes/office excel icon.svg
// module id = ./app/web/src/assets/filetypes/office excel icon.svg
// module chunks = 0